import React, {useEffect, useState} from "react";
import 'react-calendar/dist/Calendar.css';
import {Card, CardBody, CardHeader, CardTitle, Col, Row} from "reactstrap";
import IconButton from '@mui/material/IconButton';
import EditNoteIcon from '@mui/icons-material/EditNote';
import Tooltip from '@mui/joy/Tooltip';
import {Typography, Grid, Button} from '@material-ui/core';
import HomeIcon from '@mui/icons-material/Home';
import LocalPhoneIcon from '@mui/icons-material/LocalPhone';
import EmailIcon from '@mui/icons-material/Email';
import axios from "axios";
import Cookies from "js-cookie";
import moment from "moment-jalali";
import BookmarksIcon from "@mui/icons-material/Bookmarks";

const cardStyle={
	backgroundColor:'#ebeff3',
	borderRadius:'25px',
	padding:'10px',
}

function ProfileInfo(props) {

	const [data, setData] = useState([]);
	useEffect(() => {
		axios.get('https://back.actelmon.ir/api/doctor/profile/', {
			headers: {
				Authorization: `${Cookies.get('token')}` // Assuming you have a function to get the cookie value
			}
		})
			.then((response) => {
				setData(response.data);
			})
			.catch((error) => {
				console.error('Error fetching profileinfo data:', error);
			});

	}, []);

	const englishToPersianNumbers = (input) => {
		if (typeof input !== 'string' && !(input instanceof Date)) {
			console.error('Input must be a string or a Date object');
			return input;
		}

		// Define a mapping of English digits to Persian digits
		const digitMap = {
			'0': '۰',
			'1': '۱',
			'2': '۲',
			'3': '۳',
			'4': '۴',
			'5': '۵',
			'6': '۶',
			'7': '۷',
			'8': '۸',
			'9': '۹',
		};

		// Convert numbers in the input to Persian numbers
		const convertedString = input.toString().replace(/\d/g, (digit) => digitMap[digit] || digit);

		return convertedString;
	};
	const convertToSolarAndPersian = (gregorianDate) => {
		// Convert Gregorian date to Jalali (Solar) date
		if (!gregorianDate) gregorianDate = '2111-11-11'
		const solarDate = moment(gregorianDate, 'YYYY-MM-DD').format('jYYYY/jMM/jDD');

		// Convert English numbers to Persian numbers
		const persianNumbers = englishToPersianNumbers(solarDate)
		//const persianNumbers = Persian(solarDate.toString()).englishNumber().persianNumber()._str;

		return persianNumbers;
	};

	return (
		<>
			<div className="content">
				<Col lg="12" sm="12" style={{backgroundColor:'white',padding:'30px',borderRadius:'10px'}}>

					<Col lg="5" sm="5">
						<Card style={cardStyle} >
							<CardHeader className="text-right">
								<CardTitle tag="h4" style={{color:'#EBAB60',fontWeight:'bold'}}>اطلاعات شخصی</CardTitle>
							</CardHeader>

							<CardBody>
								{/*first name*/}
								<Grid container spacing={2} style={{direction:'rtl', textAlign:'right'}}>
									<Grid item xs={5}>
										<Typography gutterBottom style={{color:'#757575'}}>
											نام
										</Typography>
									</Grid>
									<Grid item xs={7}>
										<Typography gutterBottom>
											{data.name}
										</Typography>
									</Grid>
								</Grid>
								{/*last name*/}
								<Grid container spacing={2} style={{direction:'rtl', textAlign:'right'}}>
									<Grid item xs={5}>
										<Typography gutterBottom style={{color:'#757575'}}>
											نام خانوادگی
										</Typography>
									</Grid>
									<Grid item xs={7}>
										<Typography gutterBottom>
											{data.last_name}
										</Typography>
									</Grid>
								</Grid>
								{/*sex*/}
								<Grid container spacing={2} style={{direction:'rtl', textAlign:'right'}}>
									<Grid item xs={5}>
										<Typography gutterBottom style={{color:'#757575'}}>
											جنسیت
										</Typography>
									</Grid>
									<Grid item xs={7}>
										<Typography gutterBottom>
											{data.gender === 'm' ? 'مرد' : 'زن'}
										</Typography>
									</Grid>
								</Grid>
								{/*birth date*/}
								<Grid container spacing={2} style={{direction:'rtl', textAlign:'right'}}>
									<Grid item xs={5}>
										<Typography gutterBottom style={{color:'#757575'}}>
											تاریخ تولد
										</Typography>
									</Grid>
									<Grid item xs={7}>
										<Typography gutterBottom>
											{convertToSolarAndPersian(data.birth_date ? data.birth_date : '2111-11-11')}
										</Typography>
									</Grid>
								</Grid>
								{/*id*/}
								<Grid container spacing={2} style={{direction:'rtl', textAlign:'right'}}>
									<Grid item xs={5}>
										<Typography gutterBottom style={{color:'#757575'}}>
											کد شناسایی
										</Typography>
									</Grid>
									<Grid item xs={7}>
										<Typography gutterBottom>
											{englishToPersianNumbers(data.id ? data.id.toString() : '0')}
										</Typography>
									</Grid>
								</Grid>
							</CardBody>
						</Card>
					</Col>

					<Col lg="5" sm="5">
						<Card style={cardStyle} >
							<CardHeader className="text-right">
								<CardTitle tag="h4" style={{color:'#EBAB60',fontWeight:'bold'}}>اطلاعات تماس</CardTitle>
							</CardHeader>

							<CardBody>
								{/*address*/}
								<Grid container spacing={2} style={{direction:'rtl', textAlign:'right'}}>
									<Grid item xs={4}>
										<Typography gutterBottom style={{color:'#757575'}}>
											<HomeIcon sx={{margin:'5px', color:'#727272'}}/>آدرس
										</Typography>
									</Grid>
									<Grid item xs={8}>
										<Typography gutterBottom>
											{data.address}
										</Typography>
									</Grid>
								</Grid>
								{/*phone*/}
								<Grid container spacing={2} style={{direction:'rtl', textAlign:'right'}}>
									<Grid item xs={4}>
										<Typography gutterBottom style={{color:'#757575'}}>
											<LocalPhoneIcon sx={{margin:'5px', color:'#727272'}}/>تلفن
										</Typography>
									</Grid>
									<Grid item xs={8}>
										<Typography gutterBottom>
											{englishToPersianNumbers(data.username ? data.username : '-1')}
										</Typography>
									</Grid>
								</Grid>
								{/*email*/}
								<Grid container spacing={2} style={{direction:'rtl', textAlign:'right'}}>
									<Grid item xs={4}>
										<Typography gutterBottom style={{color:'#757575'}}>
											<EmailIcon sx={{margin:'5px', color:'#727272'}}/>ایمیل
										</Typography>
									</Grid>
									<Grid item xs={8}>
										<Typography gutterBottom>
											{data.email}
										</Typography>
									</Grid>
								</Grid>
							</CardBody>
						</Card>
					</Col>

					<Col lg="2" sm="2">
						<Button variant="contained"
						        style={{backgroundColor:'#138C97',color:'white'}}
						        startIcon={<EditNoteIcon sx={{marginLeft:'10px', color:'white'}} />}
						        onClick={() => props.edit(true)}
						>
							ویرایش
						</Button>
					</Col>

				</Col>
			</div>
		</>
	);
}

export default ProfileInfo;
